import React from 'react';

interface SelectFieldProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
}

/** A labelled dropdown in the app's form style, themed for light and dark mode. Takes <option>s as children. */
const SelectField: React.FC<SelectFieldProps> = ({ label, className = '', children, ...selectProps }) => (
  <label className={`block ${className}`}>
    <span className="block text-sm font-medium text-gn-secondary mb-1">{label}</span>
    <select
      {...selectProps}
      className="w-full h-9 px-3 bg-gn-input border border-gn-input rounded-md text-sm text-gn-primary focus:ring-2 focus:ring-gn-blue focus:border-transparent outline-none disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {children}
    </select>
  </label>
);

export default SelectField;
